import React, { createContext, useState } from "react";
// import { fakeAuthProvider } from "../helper/fakeAuth";

export let AuthContext = createContext(null);
const AuthProvider = ({ children }) => {
  let [user, setUser] = useState({ login: false });

  let handleRegister = async (userInfo, callback) => {
    const signUpInfo = {
      firstName: userInfo.firstName,
      lastName: userInfo.lastName,
      email: userInfo.email,
      password: userInfo.password,
    };
    let result = await fetch(
      "https://pcbplay-heroku.herokuapp.com/v1/api/auth/register",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
        },
        body: JSON.stringify(signUpInfo),
      }
    );
    result = await result.json();
    sessionStorage.setItem("jwt-token", result.data.token);
    callback();
    setUser({ info: userInfo, login: false });
  };

  let signin = async (loginDetails, callback) => {
    const loginInfo = {
      email: loginDetails.email,
      password: loginDetails.password,
    };
    let result = await fetch(
      "https://pcbplay-heroku.herokuapp.com/v1/api/auth/login",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
        },
        body: JSON.stringify(loginInfo),
      }
    );
    result = await result.json();
    sessionStorage.setItem("jwt-token", result.data.token);
    callback();
    setUser({ ...loginDetails, login: true });
  };

  let signout = (callback) => {
    // return fakeAuthProvider.signout(() => {
    // setUser({ login: false });
    //   callback();
    // });
    sessionStorage.removeItem("jwt-token");
    setUser({ login: false });
    callback();
  };

  let value = { user, signin, signout, handleRegister };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthProvider;
